import { Component, OnInit, Output, ViewChild, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from 'src/app/_services/category.service';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { VirtualFolderService } from 'src/app/_services/virtualFolder.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';

import { AppConfig } from 'src/assets/config/config/app-config';
import { User } from 'src/app/_models/user';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';


@Component({
  selector: 'app-dialog-folders-config',
  templateUrl: './dialog-folders-config.component.html',
  styleUrls: ['./dialog-folders-config.component.scss']
})
export class DialogFoldersConfigComponent implements OnInit {

  @Input() isCreateFolder: any;
  @Input() isUpdateFolder: any;
  @Input() isCreateSubFolder: any
  @Input() selectedFolderId: any;
  @Output() isMainPage = new EventEmitter<boolean>();
  @Output() alertErrorMessage = new EventEmitter<string>();
  allCategories = []
  createFormData: FormGroup
  fetchedFolderId: any;
  fetchedParentId: any
  allCategoryProperties = []
  searchCtrl: string = "";
  allGroups: string[] = [];
  query: any
  folder: any
  isFolderCreated: boolean = false
  public inOperators: string[] = ['in', 'notin'];
  public showButtons: Object = { groupInsert: false, groupDelete: true, ruleDelete: true }
  criteriaQuery: any;
  fetchedFolderName: string
  properties = []
  displayInList = []
  fetchedGroups: string[] = [];
  currentUser: User;
  showOwner: boolean = false
  userGroups: string[]
  isAdmin: boolean = false
  isDjango: boolean

  public data: Object[];

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private virtualFolderService: FileInboxVirtualFolderService,
    private groupService: UsersAndGroupsService,
    private authenticationService: AuthenticationService,
    private cdref: ChangeDetectorRef,
    private config: AppConfig
  ) {

    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = this.authenticationService.userGroupsValue;
    this.isAdmin = this.authenticationService.isAdminValue;
    this.isDjango = this.config.getConfig('isDjango')
    this.createFormData = this.fb.group({
      folder_name: ['', Validators.required],      
      groups: [''],
      personal: [true]
    })
  }

  ngOnInit() {
    if (!this.isAdmin) {
      this.fetchedGroups = this.userGroups;
      this.allGroups = this.userGroups;
    } else {
      this.groupService.getAllGroups().subscribe(groups => {
        if (this.isDjango) {
          this.fetchedGroups = groups;
          this.allGroups = groups;
          } else {
          this.fetchedGroups = [];
          this.allGroups = [];
          if (groups.Users && groups.Users.length > 0) {
            for (var i = 0; i < groups.Users.length; i++) {
              this.fetchedGroups.push(groups.Users[i].Username);
              this.allGroups.push(groups.Users[i].Username);
            }
          } else {
            this.fetchedGroups = groups;
            this.allGroups = groups;
          }
        }
        console.log(this.fetchedGroups);
      });
    }

    if (this.selectedFolderId) {
      this.virtualFolderService.getFolderDetails(this.selectedFolderId).subscribe(folder => {
        this.fetchedFolderName = folder.folder_name
        this.fetchedFolderId = folder.id
        this.fetchedParentId = folder.parent_id
        if (this.isUpdateFolder) {
          this.setUpdateFormData(folder)          
        }

      });
    }    
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }


  setUpdateFormData(folder) {

    this.properties = folder.display_list
    var data = {
      folder_name: folder.folder_name,
      category_id: folder.category_id,
      display_list: folder.display_list,
      search: folder.search,
      groups: folder.groups,
      personal: folder.personal,
      owner: folder.owner,
    }
    if (data.personal) {
      this.showOwner = true;
    }
    this.createFormData.patchValue(data)
  }

  togglePersonal() {
    this.showOwner = !this.showOwner;    
  }
  saveUpdateData(formData) {
    formData.id = this.fetchedFolderId
    formData.parent_id = this.fetchedParentId
    this.virtualFolderService.updateFolder(formData).subscribe(resp => {
      this.isFolderCreated = true
      console.log("Folder updated", resp)
    }, error => {
      this.alertErrorMessage.emit("User does not have permission to update the folder ");
    })
  }

  back(refresh) {
      this.isMainPage.emit(refresh);
      this.createFormData.reset()
  }

  saveCreateData(formData) {
    console.log("Create form data", this.createFormData.value['folder_name'])
    if (this.isCreateFolder == true) {
      formData.parent_id = 0
    }
    else if (this.isCreateSubFolder == true) {
      formData.parent_id = this.fetchedFolderId
    }
    if (formData.personal == true) {
      this.virtualFolderService.createFolder(formData).subscribe(resp => {
        this.isFolderCreated = true
        console.log("Folder created", resp)
      })
    }
    else {
      formData.personal = false
      this.virtualFolderService.createFolder(formData).subscribe(resp => {
        this.isFolderCreated = true
        console.log("Folder created", resp)
      })
    }

  }

}
